import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';

interface ImpactCategoryBySdg {
  [id: string]: ImpactCategoryId[];
}

const sdgImpactMapping: ImpactCategoryBySdg = {
  [SdgId._1_No_Poverty]: [ImpactCategoryId.EQUALITY],
  [SdgId._2_Zero_Hunger]: [ImpactCategoryId.NUTRITION],
  [SdgId._3_Good_Health_and_Wellbeing]: [
    ImpactCategoryId.PHYSICAL_DISEASES,
    ImpactCategoryId.MENTAL_DISEASES,
    ImpactCategoryId.NUTRITION,
    ImpactCategoryId.MEANING_AND_JOY,
  ],
  [SdgId._4_Quality_Education]: [ImpactCategoryId.KNOWLEDGE_INFRA, ImpactCategoryId.DISTRIBUTING_KNOWLEDGE],
  [SdgId._5_Gender_Equality]: [ImpactCategoryId.EQUALITY],
  [SdgId._6_Clean_Water_and_Sanitation]: [ImpactCategoryId.SCARCE_NATURAL_RESOURCES, ImpactCategoryId.SOCIETAL_INFRA],
  [SdgId._7_Affordable_and_Clean_Energy]: [
    ImpactCategoryId.GHG_EMISSIONS,
    ImpactCategoryId.NON_GHG_EMISSIONS,
    ImpactCategoryId.SOCIETAL_INFRA,
  ],
  [SdgId._8_Decent_Work_and_Economic_Growth]: [
    ImpactCategoryId.TAXES,
    ImpactCategoryId.JOBS,
    ImpactCategoryId.SOCIETAL_INFRA,
    ImpactCategoryId.EQUALITY,
  ],
  [SdgId._9_Industry_Innovation_and_Infrastructure]: [
    ImpactCategoryId.JOBS,
    ImpactCategoryId.SOCIETAL_INFRA,
    ImpactCategoryId.KNOWLEDGE_INFRA,
    ImpactCategoryId.CREATES_KNOWLEDGE,
  ],
  [SdgId._10_Reduced_Inequality]: [ImpactCategoryId.EQUALITY],
  [SdgId._11_Sustainable_Cities_and_Communities]: [ImpactCategoryId.NON_GHG_EMISSIONS, ImpactCategoryId.SOCIETAL_INFRA],
  [SdgId._12_Responsible_Consumption_and_Production]: [ImpactCategoryId.WASTE],
  [SdgId._13_Climate_Action]: [ImpactCategoryId.GHG_EMISSIONS, ImpactCategoryId.NON_GHG_EMISSIONS],
  [SdgId._14_Life_Below_Water]: [ImpactCategoryId.BIODIVERSITY, ImpactCategoryId.NON_GHG_EMISSIONS],
  [SdgId._15_Life_on_Land]: [ImpactCategoryId.BIODIVERSITY, ImpactCategoryId.NON_GHG_EMISSIONS],
  [SdgId._16_Peace_Justice_and_Strong_Institutions]: [
    ImpactCategoryId.RELATIONSHIPS,
    ImpactCategoryId.SOCIETAL_STABILITY,
  ],
  [SdgId._17_Partnerships_for_the_Goals]: [ImpactCategoryId.DISTRIBUTING_KNOWLEDGE],
};

export function getImpactCategoriesForSdg(id: SdgId): ImpactCategoryId[] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return sdgImpactMapping[id] || [];
}
